// @ts-nocheck

import React, { useCallback, useMemo, useState } from 'react';

import useMergeProps from '../../../../hooks/useMergeProps';
import BetshareContainer from '../../../betshare/containers/BetshareContainer';
import { useBetslipOptionsContext } from '../../context/BetslipOptionsContext';

import BetslipOptionsShareImageItem from './BetslipOptionsShareImageItem';

const BetslipOptionsShareImageItemContainer = () => {
  const { betslipRef, onCloseModal } = useBetslipOptionsContext();
  const [isShareOpen, setIsShareOpen] = useState(false);

  const onShareButtonClick = useCallback(() => {
    setIsShareOpen(true);
  }, []);

  const onCloseShare = useCallback(() => {
    setIsShareOpen(false);

    if (onCloseModal) {
      onCloseModal();
    }
  }, [onCloseModal]);

  const otherProps = useMemo(() => ({ onClick: onShareButtonClick }), [onShareButtonClick]);

  const enhancedProps = useMergeProps({ otherProps });

  return betslipRef ? (
    <>
      {isShareOpen ? <BetshareContainer betslipReference={betslipRef} onClose={onCloseShare} /> : null}
      <BetslipOptionsShareImageItem {...enhancedProps} />
    </>
  ) : null;
};

export default BetslipOptionsShareImageItemContainer;
